import { useRoomStore } from '@/stores/room'

//TODO there is a bug that if someone votes and then starts spectating, their score is still considered in the average
export function getScore(votes) {
  if (!votes) {
    return null
  }

  console.log(votes)

  const roomStore = useRoomStore()
  const cards = roomStore.cards

  const averageIndex = Math.round(Object.values(votes).map(item => item.score).reduce((acc, item) => {
    try {
      const score = parseInt(item)
      
      if (isNaN(score)) {
        return acc
      }
      if(score > cards.length - 1) {
        return acc + cards.length - 1
      }

      return acc + score
    } catch (e) {
      return acc
    }
  }, 0) / Object.values(votes).length)

  console.log(averageIndex)
  if(averageIndex === undefined){
    return null
  }

  return cards[averageIndex].toString()
}
